import {
  Box,
  styled,
  TableCell,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import React from "react";

export const StyledTableWrapper = styled(Box)(({ theme: { palette, spacing } }) => ({
  background: palette.main[50],
  padding: `0 ${spacing(3)}`,
  borderRadius: spacing(1.5),

  "& td, & th": {
    borderColor: palette.divider,
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
  },

  "& tr:last-child": {
    "& td": {
      borderBottom: "none",
    },
  },
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme: { spacing } }) => ({
  paddingTop: spacing(8),
  paddingBottom: spacing(3),
}));

export const StyledTableCell = styled(TableCell)(({ theme: { spacing } }) => ({
  paddingTop: spacing(3),
  paddingBottom: spacing(3),
}));

export const CurrentFeatureTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip
      {...props}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -2],
              },
            },
          ],
        },
      }}
      classes={{ popper: className }}
    >
      {props.children}
    </Tooltip>
  ),
)(({ theme: { palette } }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: palette.custom.purple[100],
    color: palette.custom.purple[800],
    borderRadius: 4,
    padding: "6px 8px",
  },

  [`& .${tooltipClasses.arrow}`]: {
    color: palette.custom.purple[100],
  },
}));
